import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Clearfix,
  Col,
  Glyphicon,
  Row,
} from 'react-bootstrap';

import TicketUploadSubmissionModal, {
  uploadSubmissionItemModalPropTypes,
  withUploadSubmissionItemModalState,
} from '../../tickets/attachments/TicketUploadSubmissionModal';

import TicketAttachmentsTableModal, {
  attachmentsModalPropTypes,
  withAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentsTableModal';

import TicketAttachmentUploadModal, {
  uploadAttachmentsModalPropTypes,
  withUploadAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentUploadModal';

import MissingTimeEntriesModal, {
  missingTimeEntriesModalPropTypes,
  withMissingTimeEntriesModalState,
} from './MissingTimeEntriesModal';

import TicketFacts from '../../tickets/components/TicketFacts';
import TicketUserHourSummary from '../../tickets/components/TicketUserHourSummary';
import TicketSubmissionItemDownloadButton from '../../tickets/components/TicketSubmissionItemDownloadButton';
import TicketSubmissionItemViewer from '../../tickets/components/TicketSubmissionItemViewer';
import TicketVariableEditor, { getFormState } from '../../tickets/components/TicketVariablesEditor';
import FormWrapperEnhanced from '../../forms/TicketEntry/components/FormWrapperEnhanced';
import JobFacts from '../../tickets/components/JobFacts';
import TicketCaluclatedFields from '../../tickets/components/TicketCalculatedFields';
import { openTicketEntryForm } from '../../forms/TicketEntry/actions';
import { getUserFeatures } from '../../authentication/selectors';

const propTypes = exact({
  ticketId: PropTypes.number.isRequired,
  reviewTicketId: PropTypes.func.isRequired,
  canReviewTicket: PropTypes.bool.isRequired,
  pristine: PropTypes.object.isRequired,
  openTicketEntryFormAction: PropTypes.func.isRequired,
  documentId: PropTypes.number.isRequired,
  isJobMutable: PropTypes.bool.isRequired,
  features: PropTypes.object.isRequired,
  hasTimeEntries: PropTypes.bool.isRequired,
  jobId: PropTypes.number.isRequired,

  ...attachmentsModalPropTypes,
  ...uploadAttachmentsModalPropTypes,
  ...uploadSubmissionItemModalPropTypes,
  ...missingTimeEntriesModalPropTypes,
});


const TicketApprovalPanel = (props) => {
  const {
    jobId,
    canReviewTicket,
    pristine,
    ticketId,
    reviewTicketId,
    openTicketEntryFormAction,
    features,
    isJobMutable,
  } = props;

  const {
    showSubmissionItemModal, closeUploadSubmissionItemModal, openUploadSubmissionItemModal,
  } = props;

  const {
    showViewAttachmentsModal, closeViewAttachmentsModal, openViewAttachmentsModal,
  } = props;

  const {
    showUploadAttachmentsModal, closeUploadAttachmentsModal, openUploadAttachmentsModal,
  } = props;

  const {
    showMissingTimeEntriesModal, openMissingTimeEntriesModal, closeMissingTimeEntriesModal,
  } = props;

  const {
    update_immutable_tickets: updateImmutableTickets,
  } = features;

  const disableReview = () => {
    return (!canReviewTicket || !pristine);
  };

  const handleMarkingTicketReviewed = () => {
    const { hasTimeEntries } = props;
    if (hasTimeEntries) {
      reviewTicketId();
    } else {
      openMissingTimeEntriesModal();
    }
  };

  const canEdit = (isJobMutable || updateImmutableTickets);

  return (
    <div className="panel-body">
      <div className="panel panel-default">
        <div className="panel-body">
          <Row>
            <Col xs={6}>
              <TicketSubmissionItemViewer ticketId={ticketId} />
            </Col>
            <Col xs={6}>
              <TicketFacts ticketId={ticketId} />
              <div className="panel panel-default">
                <TicketUserHourSummary ticketId={ticketId} />
              </div>
              <Row>
                <Col md={7}>
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <TicketVariableEditor ticketId={ticketId} disabled={!canEdit} />
                    </div>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <TicketCaluclatedFields ticketId={ticketId} />
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="panel panel-default">
                <JobFacts ticketId={ticketId} />
              </div>
            </Col>
          </Row>
        </div>
        <div className="panel-footer">
          <Clearfix>
            <ButtonToolbar className="pull-left">
              <TicketSubmissionItemDownloadButton ticketId={ticketId} />
              <Button bsStyle="primary" onClick={openUploadSubmissionItemModal}>
                Replace Ticket
              </Button>
              {canEdit && (
                <Button bsStyle="warning" onClick={() => { openTicketEntryFormAction(); }}>
                  <Glyphicon glyph="edit" style={{ marginRight: '0.5em' }} />
                  Edit Ticket
                </Button>
              )}
              <ButtonGroup>
                <Button onClick={openViewAttachmentsModal}>
                  View Attachments
                </Button>
                <Button onClick={openUploadAttachmentsModal}>
                  Upload Attachment
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
            <ButtonToolbar className="pull-right">
              <Button bsStyle="primary" disabled={disableReview()} onClick={handleMarkingTicketReviewed}>
                <Glyphicon glyph="eye-open" style={{ marginRight: '0.5em' }} />
                Mark Ticket Reviewed
              </Button>
            </ButtonToolbar>
          </Clearfix>
        </div>
      </div>
      <FormWrapperEnhanced
        ticketId={ticketId}
        canEdit={canEdit}
        jobId={jobId}
      />
      <div>
        <TicketUploadSubmissionModal
          onHide={closeUploadSubmissionItemModal}
          show={showSubmissionItemModal}
          ticketId={ticketId}
        />
        <TicketAttachmentsTableModal
          show={showViewAttachmentsModal}
          onHide={closeViewAttachmentsModal}
          ticketId={ticketId}
        />
        <TicketAttachmentUploadModal
          show={showUploadAttachmentsModal}
          onHide={closeUploadAttachmentsModal}
          ticketId={ticketId}
        />
        <MissingTimeEntriesModal
          title="Missing Time Entries"
          message="Missing Time Entries on Ticket"
          show={showMissingTimeEntriesModal}
          onHide={closeMissingTimeEntriesModal}
          onSubmit={reviewTicketId}
        />
      </div>
    </div>
  );
};

TicketApprovalPanel.propTypes = propTypes;

const mapDispatchToProps = {
  openTicketEntryFormAction: openTicketEntryForm,
};

const mapStateToProps = (state) => {
  return {
    features: getUserFeatures(state),
    pristine: getFormState(state),
  };
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withAttachmentsModalState,
  withUploadAttachmentsModalState,
  withUploadSubmissionItemModalState,
  withMissingTimeEntriesModalState,
);

export default enhance(TicketApprovalPanel);
